export interface MpfBackLinkProps {
  href?: string;
  text?: string;
  reverse?: boolean;
  ariaLabel?: string;
  fallbackUrl?: string;
  historyBack?: boolean;
}

export const defaultProps: Partial<MpfBackLinkProps> = {
  href: '#',
  text: 'Back',
  reverse: false,
  ariaLabel: '',
};

export const emitDef = {
  click: (_event: MouseEvent) => true,
};
